import gql from 'graphql-tag'

export default gql`
    query AvailableCities($zipcode: String!) {
        availableCities(zipcode: $zipcode) {
            city
            district
        }
    }
`
